import { ExecFileOptionsWithStringEncoding } from "child_process";

export interface IVehicleFileForm {
    vehicle: number;
    activity_type: number;
    description: string;
    document: any;
    activity_fulfilled_at: Date;
}
export class VehicleActivityTypes {
    public id?: number;
    public customer?: number; // max 32 chracters
    public schedule_type?: number;
    public name?: string;
    public require_user_date_input?: Date;
}

export interface IVehicleActivityRow {
    activity_fulfilled_at: Date;
    activity_type: number;
    created_at: Date;
    created_by: string;
    description: string;
    document?: any;
    fulfilled_scheduled_activity?: IScheduledActivity;
    id: number;
}
export interface IPaginatedVehicleActivityRow {
    count: number;
    next: string;
    previous: string;
    results: IVehicleActivityRow[];
}


export interface IScheduledActivity {
    id: number;
    due_at: Date;
    status: string;
    schedule_type: number;
    vehicle: number;
}
export interface IVehicleActivityApiParams {
    activity_type?: number;
    depot?: number;
    region?: number;
    date_range?: string; // dd-mm-yyyy,dd-mm-yyyy
    fulfilled_at_date_range?: string; // dd-mm-yyyy,dd-mm-yyyy
    vehicle?: number;
    filter_latest: string; // True of null
    page?: number;
    pageSize?: number;
    ordering?: string;
    archived?: string; // True or null
    has_pending_investigations?: boolean;
    investigation_status?: string; // comma-delimited InvestigationStatus list
}
export class VehicleGroupDepots {
    public id?: number;
    public name?: string;
}

/**
 * The statuses an investigation moves through. REQUIRES_FORM_TYPE has no form
 * yet, so it carries no questions or answers.
 */
export type InvestigationStatus =
    'REQUIRES_FORM_TYPE' |
    'PENDING' |
    'REQUIRES_APPROVAL' |
    'APPROVAL_REJECTED' |
    'COMPLETE';

export const INVESTIGATION_STATUS = {
    REQUIRES_FORM_TYPE: 'REQUIRES_FORM_TYPE' as InvestigationStatus,
    PENDING: 'PENDING' as InvestigationStatus,
    REQUIRES_APPROVAL: 'REQUIRES_APPROVAL' as InvestigationStatus,
    APPROVAL_REJECTED: 'APPROVAL_REJECTED' as InvestigationStatus,
    COMPLETE: 'COMPLETE' as InvestigationStatus
};

/** Module permission names gating each step of the investigation flow */
export const INVESTIGATION_PERMISSION = {
    ASSIGN_FORM_TYPE: 'canAssignInvestigationFormType',
    FILL_FORM: 'canFillInvestigationForm',
    APPROVE: 'canApproveInvestigation'
};

/** One of the forms selectable under an investigation's template */
export interface IInvestigationFormType {
    id: number;
    title: string;
    requires_approval: boolean;
    question_count: number;
}

export interface IInvestigationReview {
    id: number;
    reviewer: string;
    decision: 'APPROVED' | 'REJECTED';
    comment: string;
    signature?: string;
    created_at: Date;
}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_models/vehicle-file.ts